export default "__VITE_ASSET__CikZenjr__"